import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { AccordionStyled, PopUpContainer } from "assets/css/globle";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import { CircleBtn } from "assets/css/globle";
import { SiteSettingModalContainer } from "pages/Map/MapStyled";
import CloseIcon from "assets/svgIcons/CloseIcon";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import {
  Heading,
  WorkSection,
  ActionWrapper,
} from "pages/Admin/SiteSettings/SettingStyled";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "../../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { mapHelpers } from "../../../Pins/utils/mapHelpers";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, Modal, Tooltip, Typography } from "@mui/material";
import Button from "@mui/material/Button";

import _ from "lodash";
import { CheckIcon, UncheckIcon } from "assets/svgIcons";
import { Loader2 } from "commonComponents/Loader/Loader";
import { ADMIN_SITE_CONFIG, SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";

const HoleDataSettings = () => {
  const {
    siteSettingsData,
    siteSetupData,
    deleteTeeSettingsStatus,
    setUpdatedTeeMarkerSettingsStatus,
    addNewTeeMarkerSettingsStatus,
    teeMarkerLoaderStatus,
  } = useSelector((state) => state.commonReducers) || [];

  const dispatch = useDispatch();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showOnVduAlert, setShowOnVduAlert] = useState(false);
  const [showOnVduText, setShowOnVduText] = useState("");
  const [showModal2, setShowModal2] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [sharedCheckbox, setSharedCheckbox] = useState(false);
  const [showOnVduName, setShowOnVduName] = useState(false);
  const [showOnVduColor, setShowOnVduColor] = useState(false);
  const [backupSharedButton, setBackupSharedButton] = useState(false);
  const [courseName, setCourseName] = useState([]);
  const [courseNameDetector, setCourseNameDetector] = useState("");
  const [backupTeeMarkerData, setBackupTeeMarkerData] = useState([]);
  const [teeMarkerSettingsData, setTeeMarkerSettingsData] = useState([]);
  const [addedTeeMarkerSettingsData, setAddedTeeMarkerSettingsData] = useState(
    []
  );
  const [cancelData, setCancelData] = useState(false);
  const [courseNumberData, setCourseNumberData] = useState(null);
  const { t } = useTranslation();
  const [deletedItem, setDeletedItem] = useState([]);
  const { isTSModified } = useHookstate(ADMIN_SITE_CONFIG);
  const [saveTeeMarkerModal, setSaveTeeMarkerModal] = useState(false);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
    setDeletedItem([]);
    setDisabledButton(true);
  }, [
    siteSettingsData,
    siteId.get(),
    setUpdatedTeeMarkerSettingsStatus,
    addNewTeeMarkerSettingsStatus,
    deleteTeeSettingsStatus,
  ]);

  useEffect(() => {
    if (courseNameDetector && courseNumberData) {
      setCourseNameDetector(courseNameDetector);
      setCourseNumberData(courseNumberData);
      showCourseData(courseNumberData);
    } else {
      if (
        siteSettingsData &&
        siteSettingsData?.Courses &&
        siteSettingsData?.Courses?.length !== 0
      ) {
        setCourseNameDetector(siteSettingsData?.Courses[0]?.Name);
        setCourseNumberData(siteSettingsData?.Courses[0]?.Number);
        showCourseData(siteSettingsData?.Courses[0]?.Number);
      }
    }
  }, [siteSettingsData]);

  useEffect(() => {
    let teeMarkersList = [];

    if (siteSetupData && Object.keys(siteSetupData).length !== 0) {
      setSharedCheckbox(siteSetupData?.UsingSharedTeeSettings);
      setBackupSharedButton(siteSetupData?.UsingSharedTeeSettings);
    }

    if (siteSetupData && Object.keys(siteSetupData).length !== 0 &&
      siteSetupData?.TeeMarkerSettings &&
      siteSetupData?.TeeMarkerSettings.length !== 0) {
      siteSetupData?.TeeMarkerSettings.forEach(function (teeData) {
        teeMarkersList.push({
          Name: teeData?.Name,
          CourseId: teeData?.CourseId,
          CourseNumber: teeData?.CourseNumber,
          Id: teeData?.Id,
          Index: teeData?.Index,
          SiteId: teeData?.SiteId,
          ColorRGB: teeData?.ColorRGB
            ? "#" + mapHelpers.convIntToRGB(teeData?.ColorRGB)
            : teeData?.ColorRGB === 0
              ? "#FFFFFF"
              : "#" +
              mapHelpers.convIntToRGB(
                mapHelpers.convRGBToInt(
                  mapHelpers.getDefaultCourseColors(teeData?.CourseNumber)
                )
              ),
          ShowTeeNameOnVDU: teeData?.ShowTeeNameOnVDU,
          ShowTeeColorOnVDU: teeData?.ShowTeeColorOnVDU
        });
      });
      setTeeMarkerSettingsData(teeMarkersList);
      setBackupTeeMarkerData(teeMarkersList);
      if (courseNameDetector && courseNumberData && !siteSetupData?.UsingSharedTeeSettings) {
        setCourseNameDetector(courseNameDetector);
        setCourseNumberData(courseNumberData);
        showCourseData(courseNumberData);
      } else {
        if (siteSettingsData &&
          siteSettingsData?.Courses &&
          siteSettingsData?.Courses?.length !== 0 &&
          !siteSetupData?.UsingSharedTeeSettings) {
          setCourseNameDetector(siteSettingsData?.Courses[0]?.Name);
          setCourseNumberData(siteSettingsData?.Courses[0]?.Number);
          showCourseData(siteSettingsData?.Courses[0]?.Number);
        }
      }
    }
  }, [siteSetupData, siteId.get(), siteSettingsData]);

  // Handling Shared Button
  useEffect(() => {
    if (sharedCheckbox) {
      if (
        siteSettingsData &&
        siteSettingsData?.Courses &&
        siteSettingsData?.Courses?.length !== 0
      ) {
        let courseNames = siteSettingsData?.Courses.map((item) => {
          return item;
        });
        setCourseName(courseNames);
      }
    } else {
      if (
        siteSettingsData &&
        siteSettingsData?.Courses &&
        siteSettingsData?.Courses?.length !== 0
      ) {
        setCourseNameDetector(siteSettingsData?.Courses[0]?.Name);
        setCourseNumberData(siteSettingsData?.Courses[0]?.Number);
        showCourseData(siteSettingsData?.Courses[0]?.Number);
      }
    }
  }, [sharedCheckbox]);

  // For Courses Button
  useEffect(() => {
    if (
      siteSettingsData &&
      siteSettingsData?.Courses &&
      siteSettingsData?.Courses?.length !== 0
    ) {
      let courseNames = siteSettingsData?.Courses.map((item) => {
        return item;
      });
      setCourseName(courseNames);
      if (courseNameDetector && courseNumberData) {
        setCourseNameDetector(courseNameDetector);
        setCourseNumberData(courseNumberData);
        showCourseData(courseNumberData);
      } else {
        if (
          siteSettingsData &&
          siteSettingsData?.Courses &&
          siteSettingsData?.Courses?.length !== 0
        ) {
          setCourseNameDetector(siteSettingsData?.Courses[0]?.Name);
          setCourseNumberData(siteSettingsData?.Courses[0]?.Number);
          showCourseData(siteSettingsData?.Courses[0]?.Number);
        }
      }
    }
  }, [siteSettingsData, siteId.get()]);

  useEffect(() => {
    if(siteSettingsData?.Courses?.length > 0) {
      let selectedCourseData = siteSettingsData?.Courses.filter(x => x.Number == courseNumberData);
      selectedCourseData = selectedCourseData[0];

      if(selectedCourseData) {
        setShowOnVduName(selectedCourseData.ShowTeeNameOnVDU);
        setShowOnVduColor(selectedCourseData.ShowTeeColorOnVDU);
      }
    }
  }, 
  [courseNumberData]);

  const addTeeMarkerData = () => {
    if (
      siteSetupData &&
      siteSetupData?.TeeMarkerSettings &&
      siteSetupData?.TeeMarkerSettings.length !== 0
    ) {
      if (teeMarkerSettingsData.length < 8) {
        // add input box
        setTeeMarkerSettingsData([
          ...teeMarkerSettingsData,
          {
            ColorRGB: "#FFFFFF",
            CourseId: 0,
            CourseNumber: teeMarkerSettingsData[0]?.CourseNumber
              ? teeMarkerSettingsData[0]?.CourseNumber
              : courseNumberData,
            Id: 0,
            Index: 0,
            Name: "",
            siteId: siteId.get(),
            newId: new Date().getTime(),
            ShowTeeNameOnVDU: false,
            ShowTeeColorOnVDU: false
          },
        ]);
        setAddedTeeMarkerSettingsData([
          ...addedTeeMarkerSettingsData,
          {
            ColorRGB: "#FFFFFF",
            CourseId: 0,
            CourseNumber: teeMarkerSettingsData[0]?.CourseNumber
              ? teeMarkerSettingsData[0]?.CourseNumber
              : courseNumberData,
            Id: 0,
            Index: 0,
            Name: "",
            siteId: siteId.get(),
            newId: new Date().getTime(),
            ShowTeeNameOnVDU: false,
            ShowTeeColorOnVDU: false
          },
        ]);
        setDisabledButton(false);
      } else {
        // show popup alert
        setShowModal(true);
      }
    }
  };

  const showCourseData = (courseNumber) => {
    if (courseNumber && siteSetupData && Object.keys(siteSetupData).length !== 0) {
      if (
        siteSetupData?.TeeMarkerSettings &&
        siteSetupData?.TeeMarkerSettings.length !== 0
      ) {
        let teeMarkerData = [];
        const findCourseData = siteSetupData?.TeeMarkerSettings.filter(
          (item) => item?.CourseNumber === courseNumber
        );

        const newlyAddedTeeMarkerData =
          addedTeeMarkerSettingsData && addedTeeMarkerSettingsData.length !== 0
            ? addedTeeMarkerSettingsData?.filter(
              (item) => item?.CourseNumber === courseNumber
            )
            : [];

        findCourseData.forEach(function (teeData) {
          teeMarkerData.push({
            Name: teeData?.Name,
            CourseId: teeData?.CourseId,
            CourseNumber: teeData?.CourseNumber,
            Id: teeData?.Id,
            Index: teeData?.Index,
            SiteId: teeData?.SiteId,
            ColorRGB: teeData?.ColorRGB
              ? "#" + mapHelpers.convIntToRGB(teeData?.ColorRGB)
              : teeData?.ColorRGB === 0
                ? "#FFFFFF"
                : "#" +
                mapHelpers.convIntToRGB(
                  mapHelpers.convRGBToInt(
                    mapHelpers.getDefaultCourseColors(teeData?.CourseNumber)
                  )
                ),
            ShowTeeNameOnVDU: teeData?.ShowTeeNameOnVDU,
            ShowTeeColorOnVDU: teeData?.ShowTeeColorOnVDU
          });
        });
        setTeeMarkerSettingsData([
          ...teeMarkerData,
          ...newlyAddedTeeMarkerData,
        ]);
      }
    }

    if (
      courseNumber === "" &&
      siteSetupData &&
      Object.keys(siteSetupData).length !== 0
    ) {
      let teeMarkerData = [];
      siteSetupData?.TeeMarkerSettings.forEach(function (teeData) {
        teeMarkerData.push({
          Name: teeData?.Name,
          CourseId: teeData?.CourseId,
          CourseNumber: teeData?.CourseNumber,
          Id: teeData?.Id,
          Index: teeData?.Index,
          SiteId: teeData?.SiteId,
          ColorRGB: teeData?.ColorRGB
            ? "#" + mapHelpers.convIntToRGB(teeData?.ColorRGB)
            : teeData?.ColorRGB === 0
              ? "#FFFFFF"
              : "#" +
              mapHelpers.convIntToRGB(
                mapHelpers.convRGBToInt(
                  mapHelpers.getDefaultCourseColors(teeData?.CourseNumber)
                )
              ),
          ShowTeeNameOnVDU: teeData?.ShowTeeNameOnVDU,
          ShowTeeColorOnVDU: teeData?.ShowTeeColorOnVDU
        });
      });
      setTeeMarkerSettingsData(teeMarkerData);
    }
  };

  const modifyTeeSettings = (e, i, changeDetector, newId) => {
    setDisabledButton(false);
    let tempData = [...teeMarkerSettingsData];
    if (changeDetector === "courseInput") {
      if (newId && addedTeeMarkerSettingsData.length !== 0) {
        tempData[i] = { ...tempData[i], Name: e.target.value };
        setTeeMarkerSettingsData(tempData);
        setAddedTeeMarkerSettingsData(
          addedTeeMarkerSettingsData.map((item) =>
            item?.newId === newId ? { ...item, Name: e.target.value } : item
          )
        );
      } else {
        tempData[i] = { ...tempData[i], Name: e.target.value };
        setTeeMarkerSettingsData(tempData);
      }
    } else if (changeDetector === "courseColor") {
      if (newId && addedTeeMarkerSettingsData.length !== 0) {
        tempData[i] = { ...tempData[i], ColorRGB: e.target.value };
        setTeeMarkerSettingsData(tempData);
        setAddedTeeMarkerSettingsData(
          addedTeeMarkerSettingsData.map((item) =>
            item?.newId === newId ? { ...item, ColorRGB: e.target.value } : item
          )
        );
      } else {
        tempData[i] = { ...tempData[i], ColorRGB: e.target.value };
        setTeeMarkerSettingsData(tempData);
      }
    }
  };

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-title"
              textAlign="center"
              variant="h6"
              component="h2"
            >
              {t("Tee_Marker_Setting_Error")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("The_maximum_number_of_Tee_Settings_is")}
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => setShowModal(false)}>{t("Ok")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const showPopupBox2 = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showModal2}
        onClose={() => setShowModal2(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-title"
              textAlign="center"
              variant="h5"
              component="h2"
            >
              {t("Tee_Marker_Setting_Error")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {t("This_setting_is_currently_being_used_Please_delete_all_of_the_tee_markers_using_this_setting_before_deleting_it")}
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => setShowModal2(false)}>{t("Ok")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const showSaveTeeMarkerPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={saveTeeMarkerModal}
        onClose={() => setSaveTeeMarkerModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-title"
              textAlign="center"
              variant="h6"
              component="h2"
            >
              {t("Notice")}
            </Typography>
            {teeMarkerSettingsData &&
              teeMarkerSettingsData.length > 8 &&
              !sharedCheckbox ? (
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {t("Tee_settings_are_not_shared_and_some_courses_do_not_have_tee_settings_You_will_not_be_able_add_new_tee_markers_for_those_courses_without_tee_settings")}
              </Typography>
            ) : (
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                {t("You_have_shared_tee_settings_and_there_are_too_many_max_number_allowed_is")}
              </Typography>
            )}

            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => setSaveTeeMarkerModal(false)}>{t("Ok")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const checkTeeMarkerSetting = (tSetId) => {
    // returns true if any of the elements' teeMarkers' TeeMarkersSettingId is equal to tSetId
    return _.some(siteSetupData?.TeeMarkers, { TeeMarkerSettingId: tSetId });
  };

  const deleteTeeMarker = (i, id, newId) => {
    if (
      siteSetupData &&
      siteSetupData?.TeeMarkerSettings &&
      siteSetupData?.TeeMarkerSettings.length !== 0 &&
      checkTeeMarkerSetting(id)
    ) {
      setShowModal2(true);
    } else {
      setDisabledButton(false);
      if (newId && addedTeeMarkerSettingsData.length !== 0) {
        const newTeeMarkerData = teeMarkerSettingsData.filter(
          (item, index) => index !== i
        );
        const newlyAddedTeeMarkerData = addedTeeMarkerSettingsData.filter(
          (item) => item?.newId !== newId
        );

        setTeeMarkerSettingsData(newTeeMarkerData);
        setAddedTeeMarkerSettingsData(newlyAddedTeeMarkerData);
      } else {
        const newTeeMarkerData = teeMarkerSettingsData.filter(
          (item, index) => index !== i
        );
        function getDifference(array1, array2) {
          return array1.filter((object1) => {
            return !array2.some((object2) => {
              return (
                object1.Name === object2.Name &&
                object1.ColorRGB === object1.ColorRGB
              );
            });
          });
        }
        let deletedData = getDifference(
          teeMarkerSettingsData,
          newTeeMarkerData
        );
        setDeletedItem([...deletedItem, ...deletedData]);
        setTeeMarkerSettingsData(newTeeMarkerData);
      }
    }
  };

  useEffect(() => {
    if (cancelData) {
      if (courseNameDetector && courseNumberData && !sharedCheckbox) {
        setCourseNameDetector(courseNameDetector);
        setCourseNumberData(courseNumberData);
        showCourseData(courseNumberData);
      } else {
        if (
          siteSettingsData &&
          siteSettingsData?.Courses &&
          siteSettingsData?.Courses?.length !== 0 &&
          !sharedCheckbox
        ) {
          setCourseNameDetector(siteSettingsData?.Courses[0]?.Name);
          setCourseNumberData(siteSettingsData?.Courses[0]?.Number);
          showCourseData(siteSettingsData?.Courses[0]?.Number);
        }
      }
      setCancelData(false);
    }
  }, [cancelData]);

  const cancelChanges = () => {
    setSharedCheckbox(backupSharedButton);
    setTeeMarkerSettingsData(backupTeeMarkerData);
    setDisabledButton(true);
    setAddedTeeMarkerSettingsData([]);
    setCancelData(true);
  };

  const saveTeeMarkersData = () => {
    if (!sharedCheckbox) {
      setShowAlert(true);
    }

    if (teeMarkerSettingsData.length <= 8) {
      let changedTeeMarkerData = getDifference(
        teeMarkerSettingsData,
        backupTeeMarkerData
      );

      if (changedTeeMarkerData && changedTeeMarkerData.length === 0) {
        const apiModelData0 = teeMarkerSettingsData.filter(
          (object1) =>
            !backupTeeMarkerData.some(
              (object2) => object1.Name === object2.Name
            ) ||
            !backupTeeMarkerData.some(
              (object2) => object1.ColorRGB === object2.ColorRGB
            )
        );
        if (apiModelData0 && apiModelData0.length !== 0) {
          apiModelData0.forEach((item) => {
            dispatch(
              COMMON_SERVICES.saveTeeMarkerSettingsService(item.Id, item, siteId.get())
            ).then(() => {
              setDisabledButton(true);
            });
          });
        }
      }

      function getDifference(array1, array2) {
        return array1.filter((object1) => {
          return !array2.some((object2) => {
            return (
              object1.Name === object2.Name &&
              object1.ColorRGB === object1.ColorRGB
            );
          });
        });
      }

      if (changedTeeMarkerData && changedTeeMarkerData.length !== 0) {
        const newArr = changedTeeMarkerData.map(({ newId, ...rest }) => {
          return rest;
        });

        const newlyAddedData =
          newArr && newArr.length !== 0
            ? newArr.filter((item) => item?.CourseId !== 0)
            : newArr;

        const apiModelData = newlyAddedData.map((item) => {
          return {
            ...item,
            ColorRGB: mapHelpers.convRGBToInt(item?.ColorRGB.replace("#", "")),
          };
        });

        if (apiModelData && apiModelData.length !== 0) {
          apiModelData.forEach((item) => {
            dispatch(
              COMMON_SERVICES.saveTeeMarkerSettingsService(item.Id, item, siteId.get())
            ).then(() => {
              setDisabledButton(true);
            });
          });
        }
      }

      if (
        addedTeeMarkerSettingsData &&
        addedTeeMarkerSettingsData.length !== 0
      ) {
        const newArr = addedTeeMarkerSettingsData.map(({ newId, ...rest }) => {
          return rest;
        });

        const apiModelData2 = newArr.map((item) => {
          return {
            ...item,
            ColorRGB:
              item?.ColorRGB.toUpperCase() === "#FFFFFF"
                ? "FFFFFF"
                : mapHelpers.convRGBToInt(item?.ColorRGB.replace("#", "")),
          };
        });

        if (apiModelData2 && apiModelData2.length !== 0) {
          apiModelData2.forEach((item) => {
            dispatch(COMMON_SERVICES.addTeeMarkerSettingsService(item, siteId.get()));
          });
        }
      }

      if (deletedItem && deletedItem.length !== 0) {
        deletedItem.forEach((item) => {
          dispatch(COMMON_SERVICES.deleteTeeSettingsService(item?.Id, siteId.get()));
        });
      }

      dispatch(
        COMMON_SERVICES.saveUsingSharedTeeSettingsService(sharedCheckbox, siteId.get())
      ).then(() => {
        setDisabledButton(true);
      });

      saveCourseChanges();
    } else {
      setSaveTeeMarkerModal(true);
    }
  };

  const saveCourseChanges = () => {
    if(siteSettingsData?.Courses?.length > 0) {
      let updatedCourse = JSON.parse(JSON.stringify(siteSettingsData.Courses));

      let selectedCourseIndex = updatedCourse.findIndex(x => x.Number == courseNumberData);

      if (selectedCourseIndex !== -1) {
        updatedCourse[selectedCourseIndex].ShowTeeNameOnVDU = showOnVduName ? 1 : 0;
        updatedCourse[selectedCourseIndex].ShowTeeColorOnVDU = showOnVduColor ? 1 : 0;
      }

      dispatch(COMMON_SERVICES.saveCourseChangesService(updatedCourse, siteId.get()));
    }
  }

  const handleShowNameOnVdu = (e) => {
    if(!e.target.checked && !showOnVduColor) {
      setShowOnVduAlert(true);
      setShowOnVduText("Color");
    } else {
      setShowOnVduName(e.target.checked); 
      setDisabledButton(false);
    }
  }
  
  const handleShowColorOnVdu = (e) => {
    if(!showOnVduName && !e.target.checked) {
      setShowOnVduAlert(true);
      setShowOnVduText("Name");
    } else {
      setShowOnVduColor(e.target.checked); 
      setDisabledButton(false);
    }
  }

  return (
    <>
      <AccordionStyled>
        {showPopupBox()}
        {showPopupBox2()}
        {showSaveTeeMarkerPopupBox()}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Tee_Marker_Settings")}</h3>
            </Heading>
          </AccordionSummary>
          <AccordionDetails>
            {siteSetupData &&
              siteSetupData?.TeeMarkerSettings &&
              siteSetupData?.TeeMarkerSettings?.length !== 0 ? (
              <WorkSection className="TeeMarkerSettings-main-container">
                <div className="tee-marker-settings-header">
                  <Tooltip title={t("Add_New_Tee_Setting")} arrow>
                    <button onClick={addTeeMarkerData}>
                      {t("Add_New_Tee_Setting")}
                    </button>
                  </Tooltip>
                  {!sharedCheckbox && courseName && courseName.length !== 0 ? (
                    courseName.map((item) => (
                      <button
                        className={
                          courseNameDetector === item?.Name ? "active" : ""
                        }
                        onClick={() => {
                          showCourseData(item?.Number);
                          setCourseNumberData(item?.Number);
                          setCourseNameDetector(item?.Name);
                        }}
                      >
                        {item?.Name}
                      </button>
                    ))
                  ) : (
                    <></>
                  )}
                  
                  {siteSetupData &&
                   siteSetupData?.TeeMarkerSettings &&
                   siteSetupData?.TeeMarkerSettings.length !== 0 &&
                   courseName &&
                   courseName.length > 1 ? (
                      <Tooltip title={t("Shared")} arrow>
                        <div className="checkbox-wrapper">
                          <span>
                              <FormControlLabel
                                label={t("Shared")}
                                control={
                                  <Checkbox
                                    checked={sharedCheckbox}
                                    checkedIcon={<CheckIcon />}
                                    icon={<UncheckIcon />}
                                    onChange={(e) => {
                                      showCourseData("");
                                      setSharedCheckbox(e.target.checked);
                                      setDisabledButton(false);
                                      localStorage.setItem(
                                        "courseNumberDataa",
                                        null
                                      );
                                    }}
                                  />
                                }
                              />
                          </span>
                        </div>
                      </Tooltip>
                  ) : (
                    <></>
                )}
                </div>
                <div className="TeeMarkerSettingsWrapper">
                  <table className="course-table">
                    <thead>
                      <tr>
                        <th>{t("Name")}</th>
                        <th>{t("Color")}</th>
                        <th></th>
                      </tr>
                      <tr>
                        <th>
                              <FormControlLabel
                                label={t("Show_on_VDU")}
                                control={
                                  <Checkbox
                                    checked={showOnVduName}
                                    checkedIcon={<CheckIcon />}
                                    icon={<UncheckIcon />}
                                    onChange={(e) => handleShowNameOnVdu(e)}
                                  />
                                }
                              />
                          </th>
                          <th>
                              <FormControlLabel
                                label={t("Show_on_VDU")}
                                control={
                                  <Checkbox
                                    checked={showOnVduColor}
                                    checkedIcon={<CheckIcon />}
                                    icon={<UncheckIcon />}
                                    onChange={(e) => handleShowColorOnVdu(e) }
                                  />
                                }
                              />
                          </th>
                      </tr>
                    </thead>
                    <tbody>
                      {teeMarkerSettingsData &&
                        teeMarkerSettingsData.length !== 0 ? (
                        teeMarkerSettingsData.map((item, index) => (
                          <tr>                         
                            <td>
                              <input
                                value={item?.Name}
                                onChange={(e) =>
                                  modifyTeeSettings(
                                    e,
                                    index,
                                    "courseInput",
                                    item?.newId
                                  )
                                }
                              />
                            </td>
                            <td>
                              <div className="color-wrapper">
                                <input
                                  id="style1"
                                  type="color"
                                  onChange={(e) =>
                                    modifyTeeSettings(
                                      e,
                                      index,
                                      "courseColor",
                                      item?.newId
                                    )
                                  }
                                  value={item?.ColorRGB}
                                />
                                {item?.ColorRGB.toUpperCase()}
                              </div>
                            </td>
                            <td>
                              <Tooltip title={t("Delete")} arrow>
                                <button
                                  className="cross-icon-with-border"
                                  disabled={item?.newId ? true : false}
                                  onClick={() =>
                                    deleteTeeMarker(
                                      index,
                                      item?.Id,
                                      item?.newId
                                    )
                                  }
                                >
                                  <CloseIcon
                                    color="#9BA0A4"
                                    width={15}
                                    height={15}
                                  />
                                </button>
                              </Tooltip>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <></>
                      )}
                    </tbody>
                  </table>
                  <ActionWrapper>
                    {teeMarkerLoaderStatus ? (
                      <div>
                        {" "}
                        <Loader2 />{" "}
                      </div>
                    ) : (
                      <></>
                    )}

                    <Tooltip title={t("Cancel_changes")} arrow>
                      <span>
                        <Button
                          disabled={disabledButton}
                          onClick={() => {
                            cancelChanges();
                          }}
                        >
                          {t("Cancel")}
                        </Button>
                      </span>
                    </Tooltip>

                    <Tooltip title={t("Save_changes")} arrow>
                      <span>
                        <Button
                          disabled={disabledButton}
                          onClick={() => {
                            saveTeeMarkersData();
                            isTSModified.set(true);
                            setAddedTeeMarkerSettingsData([]);
                          }}
                          className={disabledButton ? "" : "active"}
                        >
                          {t("Save")}
                        </Button>
                      </span>
                    </Tooltip>
                  </ActionWrapper>
                </div>
              </WorkSection>
            ) : (
              <div className="teemarker-settings-loader">
                {siteSetupData &&
                  siteSetupData?.TeeMarkerSettings &&
                  siteSetupData?.TeeMarkerSettings?.length !== 0
                  ? <Loader2 /> + ` Loading...`
                  : t("No_Data_Found")}
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </AccordionStyled>
      <Dialog
        aria-labelledby="draggable-dialog-title"
        open={showAlert}
        onClose={() => setShowAlert(false)}
      >
        <SiteSettingModalContainer>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {t("Notice")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tee settings are not shared and some courses do not have tee
              settings. You will not be able add new tee markers for those
              courses without tee settings.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <CircleBtn onClick={() => setShowAlert(false)}>{t("Ok")}</CircleBtn>
          </DialogActions>
        </SiteSettingModalContainer>
      </Dialog>
      <Dialog
        aria-labelledby="draggable-dialog-title"
        open={showOnVduAlert}
        onClose={() => setShowOnVduAlert(false)}
      >
        <SiteSettingModalContainer>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {t("Warning")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
            Tee {showOnVduText} is not currently shown on the VDU. You cannot clear both "Show on VDU" tee settings for a course.
            </DialogContentText>
          </DialogContent>

          <DialogActions>
            <CircleBtn onClick={() => setShowOnVduAlert(false)}>{t("Ok")}</CircleBtn>
          </DialogActions>
        </SiteSettingModalContainer>
      </Dialog>
    </>
  );
};

export default HoleDataSettings;
